import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useProfile } from '../../profile';
import type { MenuProps } from './Menu';
import { Menu } from './Menu';

export type MenuWithRouterProps = Pick<MenuProps, 'forceMenuOpenById$' | 'spaMode'>;

export function MenuWithRouter({ forceMenuOpenById$, spaMode }: MenuWithRouterProps): JSX.Element {
    const profile = useProfile();
    const location = useLocation();
    const navigate = useNavigate();
    const replaceLocation = useCallback(
        (url: string) => {
            navigate(url, { replace: true });
        },
        [navigate]
    );

    return (
        <Menu
            profile={profile}
            forceMenuOpenById$={forceMenuOpenById$}
            spaMode={spaMode}
            location={location}
            replaceLocation={replaceLocation}
        />
    );
}
